module.exports = __webpack_public_path__ + "img/lawsuit_empty.8db6778c.png";